import React from "react";

function RefrigeratedPlanCard({
  title,
  description,
  cardAosProps = {},
  titleClassName = "refrigerated-plan-title",
  descriptionClassName = "refrigerated-plan-desc",
}) {
  return (
    <div
      className="refrigerated-plan-card h-100 p-4 pt-5 d-flex flex-column justify-content-center align-items-center"
      {...cardAosProps}
    >
      <h3 className={titleClassName}>{title}</h3>
      <p className={descriptionClassName}>{description}</p>
    </div>
  );
}

export default RefrigeratedPlanCard;
